module.exports = __webpack_public_path__ + "img/mini-013.2867c95f.jpg";